import React from "react";

import { useAuth } from "@/auth/useAuth";
import { canEditTariffs } from "@/lib/warehouse-ops";
import { usePortalConfig } from "@/portal/usePortalConfig";
import { SettingsPageHeader } from "@/pages/settings/SettingsPageHeader";
import { RatesBlock } from "@/pages/warehouse-ops/RatesBlock";

const TITLE = "Тарифы склада";
const SUBTITLE = "Тарифы и нормы, по которым считается «Операции и стоимость»: версии с датой начала.";

/** Справочник тарифов и норм склада. Был на странице отчёта — переехал сюда
 *  (решение владельца 22.10.2026). Правка — по праву `warehouse_tariffs`
 *  (`canEditTariffs`), ручки тарифов те же. */
export function WarehouseTariffsSettingsPage(): React.ReactElement {
  const { user } = useAuth();
  const { hasPage } = usePortalConfig();
  return (
    <div className="mx-auto max-w-4xl space-y-6">
      <SettingsPageHeader title={TITLE} subtitle={SUBTITLE} />
      <RatesBlock canEdit={canEditTariffs(user, hasPage)} />
    </div>
  );
}
